import { CmsApiStickyHeaderLinksGradBlockData } from 'modules/cms/api/types/CmsApiStickyHeaderLinksGrad';
import { CmsBlockWidth } from 'modules/cms/api/types/CmsBlockWidth';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';

import { CmsAmpStickyHeaderLinksGradBlock } from './CmsAmpStickyHeaderLinksGradBlock';
import { CmsStickyHeaderLinksGradBlock } from './CmsStickyHeaderLinksGradBlock';

export const CmsStickyHeaderLinksGradBlockMapping: CmsBlockMapping<CmsApiStickyHeaderLinksGradBlockData> =
  {
    invariant: [
      {
        prop: 'links',
        msg: 'Links required for sticky header links',
      },
    ],
    width: CmsBlockWidth.FULL,
    Component: CmsStickyHeaderLinksGradBlock,
    AmpComponent: CmsAmpStickyHeaderLinksGradBlock,
  };
